import React, { Component } from 'react'
import { checkTranslation, translate } from '../utils/useful';

import { priceStandardView } from '../utils/useful';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import HelpButton from '../components/HelpButton';
import { nanoid } from 'nanoid';
import { v4 as uuidv4 } from 'uuid';
import TextInput from './inputs/TextInput';
import NumberInput from './inputs/NumberInput';
import { Placeholder } from 'react-bootstrap';
import PriceInput from './inputs/PriceInput';


export class CommerceInvoiceCalculations extends Component {
    state = {
        showCollapse: null,
        active: false,
        isLoading: {},
        // taxes: [{ _id: 1, title: 'GST/HST', percentage: 7, help: 'This is a test description about this tax' }, { _id: 0, title: 'PST/RST/QST', percentage: 5, help: 'This is a test description about this tax' }],

        // selected: 0,
        // checkBox: false,

        // show: false,

        // product: [
        //     { name: 'Nouveau', title: 'AirPods Pro (2ᵉ génération)', price: '299,00', src: '/images/product/photo1.jfif' },
        //     { name: 'Nouveau', title: 'Coque en cuir avec MagSafe pour iPhone 14 Pro Max - Vert forêt', price: '299,00', src: '/images/product/photo2.jfif' },
        //     { name: 'Nouveau', title: 'Apple TV 4K Wi‑Fi + Ethernet avec 128 Go de stockage', price: '299,00', src: '/images/product/photo3.jfif' },
        //     { name: 'Nouveau', title: 'HomePod mini - Gris sidéral', price: '299,00', src: '/images/product/photo4.jfif' },
        //     { name: 'Nouveau', title: 'Lanière AirTag - Rose agrume', price: '299,00', src: '/images/product/photo5.jfif' },
        // ],
        // filter: [
        //     { name: 'Categories' },
        //     { name: 'Brand' },
        //     { name: 'Price' },
        // ],
        // option: [
        //     { name: "Discounts and offers", src: '/assets/icons/target.svg' },
        //     { name: "best sellers", src: '/assets/icons/flame.svg' },
        //     { name: "amazing", src: '/assets/icons/chart.svg' },
        // ],
        // type: [
        //     { name: "{{lang}}No items saved for later", des: "{{lang}}" },
        //     { name: "{{lang}}Buy it again", des: "{{lang}}No items to Buy again" },
        // ],

        // colors: { color: "white" },

        // weeks: [
        //     { week: "Sunday", date: "18", t1: "5 pm to 6 pm", t2: "4 pm to 6 pm", t3: "19 to 21", },
        //     { week: "Monday", date: "19", t1: "13 to 16", t2: "15 to 17", t3: "19 to 21", },
        //     { week: "Tuesday", date: "20", t1: "12 to 16", t2: "17 to 18", t3: "19 to 21", },
        //     { week: "Wednesday", date: "21", t1: "15 to 19", t2: "06 to 08", t3: "19 to 21", },
        //     { week: "Thursday", date: "22", t1: "15 to 17", t2: "17 to 19", t3: "19 to 21", },
        //     { week: "Friday", date: "23", t1: "15 to 17", t2: "17 to 19", t3: "19 to 21", },
        //     { week: "Saturday", date: "24", t1: "15 to 17", t2: "17 to 19", t3: "19 to 21", },
        // ],

        // shippingTime: { time: "Sunday 2 january 4pm until 6pm" },
        // prices: [
        //     { price: "$250", title: 'tax', code: '0' },
        //     { price: "$250", title: 'Subtotal', code: '0' },
        //     { price: "Free", title: 'Shipment Cost', code: '0' },
        //     { price: "-$12", title: 'Discount', code: '1' },

        // ],

        // shippingPrice: [
        //     { price: "free" },
        // ],

        // totalPrice: { price: "$250" },

        // products: [
        //     { name: '{{lang}}airpod pro 2nd generation', colort: "{{lang}}White", colorb: "#fff", image: "/images/productbuy.png", warranty: "{{lang}}Integrated 24-month warranty (compatible, supported (Vista) and Avageng)", shop: "{{lang}}Apple Store", availability: "{{lang}}In Stuck", shipping: "{{lang}}From 1 To 2 Works Day", price: "$250" },
        //     { name: '{{lang}}airpod pro 2nd generation', colort: "{{lang}}White", colorb: "#fff", image: "/images/productbuy.png", warranty: "{{lang}}Integrated 24-month warranty (compatible, supported (Vista) and Avageng)", shop: "{{lang}}Apple Store", availability: "{{lang}}In Stuck", shipping: "{{lang}}From 1 To 2 Works Day", price: "$250" },
        //     { name: '{{lang}}airpod pro 2nd generation', colort: "{{lang}}White", colorb: "#fff", image: "/images/productbuy.png", warranty: "{{lang}}Integrated 24-month warranty (compatible, supported (Vista) and Avageng)", shop: "{{lang}}Apple Store", availability: "{{lang}}In Stuck", shipping: "{{lang}}From 1 To 2 Works Day", price: "$250" },
        //     { name: '{{lang}}airpod pro 2nd generation', colort: "{{lang}}White", colorb: "#fff", image: "/images/productbuy.png", warranty: "{{lang}}Integrated 24-month warranty (compatible, supported (Vista) and Avageng)", shop: "{{lang}}Apple Store", availability: "{{lang}}In Stuck", shipping: "{{lang}}From 1 To 2 Works Day", price: "$250" },
        //     { name: '{{lang}}airpod pro 2nd generation', colort: "{{lang}}White", colorb: "#fff", image: "/images/productbuy.png", warranty: "{{lang}}Integrated 24-month warranty (compatible, supported (Vista) and Avageng)", shop: "{{lang}}Apple Store", availability: "{{lang}}In Stuck", shipping: "{{lang}}From 1 To 2 Works Day", price: "$250" },
        //     { name: '{{lang}}airpod pro 2nd generation', colort: "{{lang}}White", colorb: "#fff", image: "/images/productbuy.png", warranty: "{{lang}}Integrated 24-month warranty (compatible, supported (Vista) and Avageng)", shop: "{{lang}}Apple Store", availability: "{{lang}}In Stuck", shipping: "{{lang}}From 1 To 2 Works Day", price: "$250" },

        // ]

    }

    // showNotifications = () => {

    // }

    // openSidebar = () => {
    //     this.sidebarView.openSidebar()
    // }
    // handleCollapse = (index) => {
    //     if (this.state.showCollapse == index) {
    //         this.setState({ active: !this.state.active })
    //     } else {
    //         this.setState({ showCollapse: index, active: true })
    //     }
    // }
    componentDidMount() {


    }


    // componentDidUpdate(prevProps, prevState) {
    //     if (prevProps.carts != this.props.carts || prevProps.taxes != this.props.taxes || this.props.voucherDiscount != prevProps.voucherDiscount) {
    //         this.cartCalculations()
    //     }
    // }


    // cartCalculations = () => {

    //     let cart = {}
    //     let taxAmounts = {}
    //     let taxes = this.state.taxes ?? []
    //     let taxesObject = {}
    //     let totalBeforeTax = 0
    //     let totalTaxable = 0
    //     let voucherDiscount = this.props.voucherDiscount


    //     taxes.forEach(tax => {
    //         taxesObject[tax._id] = tax
    //     })
    //     if (this.props.carts?.applets) {
    //         cart = this.props.carts?.applets[this.props.variables?.appletId]
    //     }

    //     if (cart) {

    //         let generalTotal = cart.totalPrice

    //         /// TO DO: Should be dynamic based on the basic config of the applet
    //         if (Array.isArray(cart.items)) {
    //             cart.items.forEach((item, index) => {
    //                 let taxId = index % 2   // TO DO: needs to be dynamic
    //                 if (taxesObject[taxId]) {
    //                     if (!taxAmounts[taxId]) {
    //                         taxAmounts[taxId] = { amount: 0, beforeTax: 0 }
    //                     }
    //                     taxAmounts[taxId].amount = taxAmounts[taxId].amount + (item.totalPrice * taxesObject[taxId].percentage / 100)
    //                     taxAmounts[taxId].beforeTax = taxAmounts[taxId].beforeTax + (item.totalPrice)
    //                     totalBeforeTax = totalBeforeTax + item.totalPrice
    //                     totalTaxable = totalTaxable + item.totalPrice

    //                 }
    //             })
    //         }

    //         if (voucherDiscount) {
    //             totalBeforeTax = totalBeforeTax - voucherDiscount
    //         }

    //         if (voucherDiscount) {
    //             totalTaxable = totalTaxable - voucherDiscount
    //         }


    //         taxes.forEach(tax => {

    //             if (taxAmounts[tax._id]) {
    //                 taxAmounts[tax._id].amount = Math.round(taxAmounts[tax._id].amount * 100) / 100
    //                 taxAmounts[tax._id].beforeTax = Math.round(taxAmounts[tax._id].beforeTax * 100) / 100
    //                 generalTotal = generalTotal + taxAmounts[tax._id].amount
    //             }
    //         });

    //         // console.log(taxAmounts)

    //         generalTotal = Math.round(generalTotal * 100) / 100


    //         this.setState({ taxAmounts, totalBeforeTax, totalTaxable, generalTotal })

    //     }

    // }


    changePage = (page, link) => {
        this.props.changePage(page)
        this.props.changeWindowLink(link)
    }

    addnewAdjustment = () => {

        let adjustments = this.props.cart?.amounts?.adjustments ?? []

        let newAdjustment = {
            id: nanoid(),
            title: "",
            amount: null,
            // mode: "discount",
            after: "discount",
            description: "",
            help: "",
        }

        adjustments.push(newAdjustment)

        this.props.updateAdjustments(adjustments)
    }

    changeAdjustmentValue = (key, value, extra) => {

        let adjustments = this.props.cart?.amounts?.adjustments ?? []

        let index = adjustments.findIndex(adjustment => adjustment.id == extra.id)

        if (index > -1) {
            adjustments[index][key] = value
        }

        this.props.updateAdjustments(adjustments)
    }

    removeAdjustment = (id) => {
        let adjustments = this.props.cart?.amounts?.adjustments ?? []

        let index = adjustments.findIndex(adjustment => adjustment.id == id)

        if (index > -1) {
            adjustments.splice(index, 1)
        }

        this.props.updateAdjustments(adjustments)
    }


    render() {

        let colors = this.props.colors
        // let background = `linear-gradient(90deg, ${colors?.primaryColor}, ${colors?.secondaryColor})`

        let cart = {}
        let taxInfo
        let amounts

        if (!this.props.adminMode && this.props.carts?.applets) {
            let appletId = this.props.variables?.appletId ?? this.props.applet?._id
            cart = this.props.carts?.applets[appletId]
            taxInfo = cart?.taxInfo
            amounts = cart?.amounts
        }

        if (this.props.adminMode) {

            cart = this.props.cart
            taxInfo = this.props.cart?.taxInfo
            amounts = this.props.cart?.amounts

        }


        if (!amounts && this.props.cart) {

            taxInfo = this.props.cart?.taxInfo
            amounts = this.props.cart?.amounts

        }

        // console.log(this.props.cart)
        // console.log(amounts)
        let currency = this.props.variables?.appletSettings?.currency ?? '$'

        let toFix = this.props.variables?.appletSettings?.decimalPlaces ?? 2


        return (

            <div className='' >
                {!this.props.adminMode && (
                    <div className='pb-2' style={{ borderBottom: '1px solid #eee' }}>
                        <p className='main-c2 weight-600 text-normal'>{translate("Order Summery")}</p>
                    </div>
                )}
                <div className='pb-1 mt-3' style={{ borderBottom: '1px solid #eee' }}>


                    <div className='flexcb pb-2'>
                        <p className='font-size-14 w-100 weight-500' style={{ color: '#000' }}>{translate("Subtotal")}</p>
                        <p className='font-size-14 weight-500' style={{ color: '#000' }}>{currency}{priceStandardView(Number(amounts?.items?.base).toFixed(toFix))}</p>
                    </div>





                    {/* 
                    {cart?.fulfillmentInfo == null ? (
                        <div className='flexcb pb-2'>
                            <p className='font-size-14 w-100 weight-500' style={{ color: '#000' }}>{translate("Delivery Fee")}</p>
                            <p className='font-size-14 weight-500' style={{ color: '#000' }}>{translate("Pending")}</p>
                        </div>
                    ) : (
                        <div className='flexcb pb-2'>
                            <p className='font-size-14 w-100 weight-500' style={{ color: '#000' }}>{translate("Delivery Fee")}</p>
                            <div>


                                <p className='font-size-14 weight-500 text-end' style={{ color: '#000' }}>{priceStandardView(Number(amounts?.fulfillments?.base ?? 0).toFixed(toFix))}{currency}</p> */}
                    {/* {amounts?.fulfillments?.discount > 0 && (
                                    <p className='text-smaller opacity-7 text-lined text-end' >${priceStandardView(Number(amounts?.fulfillments?.base).toFixed(toFix))}</p>
                                )}
                                <p className='font-size-14 weight-500 text-end' style={{ color: '#000' }}>${priceStandardView(Number(amounts?.fulfillments?.final).toFixed(toFix))}</p> */}
                    {/* </div>
                        </div>
                    )} */}
                    {/* {cart?.fulfillmentInfo == null ? (
                        <div className='flexcb pb-2'>
                            <p className='font-size-14 w-100 weight-500' style={{ color: '#000' }}>{translate("Delivery Fee")}</p>
                            <p className='font-size-14 weight-500' style={{ color: '#000' }}>{translate("Pending")}</p>
                        </div>
                    ) : (
                        <div className='flexcb pb-2'>
                            <p className='font-size-14 w-100 weight-500' style={{ color: '#000' }}>{translate("Delivery Fee")}</p>
                            <div>


                                <p className='font-size-14 weight-500 text-end' style={{ color: '#000' }}>{priceStandardView(Number(amounts?.fulfillments?.base ?? 0).toFixed(toFix))}{currency}</p>
                               
                            </div>
                        </div>
                    )} */}


                    <div className='flexcb pb-2'>
                        <p className='font-size-14 w-100 weight-500' style={{ color: 'rgb(204, 12, 57)' }}>{translate("Discount")}</p>
                        <p className='font-size-14 weight-500' style={{ color: 'rgb(204, 12, 57)' }}>{currency}-{priceStandardView(Number(amounts?.totals?.discount ?? 0).toFixed(toFix))}</p>
                    </div>


                    {/* {this.props.adminMode && (
                        <>
                            <div className='flexcb pb-2'>
                                <button>
                                    <p className='font-size-14 w-100 weight-500 text-link' >{translate("Add extra discount?")}</p>
                                </button>
                            </div>

                        </>

                    )} */}


                    {/* {this.props.adminMode && (
                        <>
                            <div className='flexcb pb-2'>
                                <button>
                                    <p className='font-size-14 w-100 weight-500 text-link' >{translate("Add voucher?")}</p>
                                </button>
                            </div>

                        </>

                    )} */}





                    {amounts?.adjustments && amounts.adjustments.map((adjustment, i) => {
                        if (adjustment.after == 'discount') {
                            return (
                                <div className='flexcb pb-2 position-relative' key={adjustment.id}>

                                    <button className='flexcc' style={{ position: 'absolute', left: -15, width: '14px', height: '14px', borderRadius: '50%', backgroundColor: '#eee' }} onClick={() => this.removeAdjustment(adjustment.id)}>
                                        <img src={'/assets/icons/remove.svg'} alt='' style={{ width: '10px', height: '10px' }} />
                                    </button>

                                    {!this.props.adminMode ? (
                                        <p className='font-size-14 w-100 weight-500' style={{ color: adjustment.amount < 0 ? 'rgb(204, 12, 57)' : null }}>{checkTranslation(adjustment.title)}</p>
                                    ) : (
                                        <div className='bordered-input flexc'>
                                            <TextInput data={adjustment.title} header={{ key: 'title', information: { placeholder: '{{lang}}Title' } }} extra={{ index: 1, id: adjustment.id }} changeValue={this.changeAdjustmentValue} />
                                        </div>
                                    )}

                                    {!this.props.adminMode ? (
                                        <p className='font-size-14 weight-500' style={{ color: adjustment.amount < 0 ? 'rgb(204, 12, 57)' : null }}>{adjustment.mode == "discount" ? "-" : ''}{currency}{priceStandardView(Number(adjustment.amount).toFixed(toFix))}</p>
                                    ) : (
                                        <div className='bordered-input mld-2 text-end flexc'>
                                            <PriceInput data={adjustment.amount} header={{ key: 'amount', information: { placeholder: '{{lang}}Amount', negativeAllowed: true } }} extra={{ index: 1, id: adjustment.id }} changeValue={this.changeAdjustmentValue} />
                                        </div>
                                    )}
                                </div>
                            )
                        }
                    })}


                    {this.props.adminMode && (
                        <>
                            <div className='flexcb pb-2'>
                                <button onClick={() => this.addnewAdjustment()} >
                                    <p className='font-size-14 w-100 weight-500 text-link' >{translate("Add adjustment")}?</p>
                                </button>
                            </div>

                        </>

                    )}


                    {this.props.voucherDiscount && (
                        <div className='flexcb pb-2'>
                            <p className='font-size-14 w-100 weight-500' style={{ color: 'rgb(204, 12, 57)' }}>{translate("Voucher Discount")}</p>
                            <p className='font-size-14 weight-500' style={{ color: 'rgb(204, 12, 57)' }}>{currency}{priceStandardView(Number(this.props.voucherDiscount).toFixed(toFix))}</p>
                        </div>
                    )}

                </div>


                {taxInfo?.taxes != null && amounts?.totals?.taxable != null && (

                    <div className='mt-2 pt-2 pb-2' style={{ borderBottom: '1px solid #eee' }}>

                        <div className='flexcb pb-2'>
                            <p className='font-size-14 weight-500 '>{translate('Total before tax')}</p>
                            <p className='font-size-14 weight-500 '>{currency}{priceStandardView(Number(amounts?.totals?.beforeTax ?? 0).toFixed(toFix))}</p>
                        </div>

                        {taxInfo?.taxes != null && amounts?.totals?.taxable != null && (
                            <div className='flexcb pb-2'>
                                <p className='font-size-14 weight-500 '>{translate('Total taxable')}</p>
                                <p className='font-size-14 weight-500 '>{currency}{priceStandardView(Number(amounts?.totals?.taxable).toFixed(toFix))}</p>
                            </div>
                        )}

                        {taxInfo?.taxes == null && (
                            <div className='flexcb pb-2'>
                                <p className='font-size-14 weight-500 '>{translate('Tax')}</p>
                                <p className='font-size-14 weight-500 '>{translate("Pending")}</p>
                            </div>
                        )}



                        {Array.isArray(taxInfo?.taxes) && taxInfo?.taxes.length > 0 && (
                            <div className='mb-1'>
                                {taxInfo?.taxes?.map((item, index) => {
                                    // if (this.state.taxAmounts && this.state.taxAmounts[tax._id]) {
                                    return (
                                        <div className='pb-1'>
                                            <div className='' key={item._id}>
                                                <div className='flexcb' >
                                                    <div className='flexc'>
                                                        <p className='font-size-14 weight-500 flexc '>{checkTranslation(item.tax?.name)}</p>
                                                        {item.tax?.description && (
                                                            <HelpButton data={item.tax?.description} />
                                                        )}
                                                    </div>

                                                    <p className='font-size-14 weight-500 '>{currency}{priceStandardView(Number(item.amount).toFixed(toFix))}</p>
                                                </div>
                                                <p className='text-smallest opacity-7'><span className='text-smallest mld-1'>%{item?.rate}</span> {`* ${item.taxable}${currency}`}</p>

                                            </div>
                                        </div>
                                    )
                                    // }
                                })}
                            </div>
                        )}


                    </div>
                )}



                <div className='py-3 flexcb' >
                    <p className='font-size-16 weight-600 '>{translate('General total')}</p>
                    <p className='font-size-16 weight-600 '>{currency}{priceStandardView(Number(amounts?.totals?.final).toFixed(toFix))}</p>
                </div>




            </div>

        )
    }
}



const mapStateToProps = state => ({ carts: state.carts, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CommerceInvoiceCalculations);